import React from 'react';

type Props = {
  width?: number;
  height?: number;
  children: React.ReactNode;
};

const VectorIcon = ({
  children,
  width = 24,
  height = 24,
}: Props): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
};

export default VectorIcon;
